;(function () {
  'use strict'

  angular.module('contrast.freemium').constant('FREEMIUM_PREFERENCES', {
    USERS: 'users.limit'
  })
})()
